/**
 * Converts a WebSocket close code to the human-readable meaning.
 */
export function getCloseCodeMeaning(code: number): string {
  const codes: Record<number, string> = {
    1000: 'Normal closure',
    1001: 'Going away (browser tab closed, etc.)',
    1002: 'Protocol error',
    1003: 'Unsupported data type',
    1004: 'Reserved',
    1005: 'No status code present',
    1006: 'Abnormal closure (no close frame)',
    1007: 'Invalid frame payload data',
    1008: 'Policy violation',
    1009: 'Message too big',
    1010: 'Missing extension',
    1011: 'Internal error',
    1012: 'Service restart',
    1013: 'Try again later',
    1014: 'Bad gateway',
    1015: 'TLS handshake failure',
    4000: 'Custom: Authentication failed',
    4001: 'Custom: Authorization failed',
    4002: 'Custom: Invalid token',
    4003: 'Custom: Token expired',
  };
  return codes[code] || `Unknown close code: ${code}`;
}
